import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';

export const useUpdateUserBlock = () => {
  const { api } = useApi({ throwIfError: true });
  const queryClient = useQueryClient();
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({
      instructions,
      userId,
      userBlockId,
    }: {
      instructions: string;
      userId: string;
      userBlockId: string;
    }) => {
      return await api({
        route: `/private/dashboard/user/${userId}/blocks/${userBlockId}/`,
        method: 'PATCH',
        payload: { instructions },
        token: userToken,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-blocks'],
      });
    },
  });

  return {
    mutation,
  };
};

export default useUpdateUserBlock;
